<template>
    <!-- <div v-if="visible" style="font-size:0.85rem;color:#9e9e9e;text-align:center;margin:1rem 0 2rem;">
        <div>{{text}}</div>
        <div style="width:50%;margin:auto;margin-top:1.1rem;">
          <v-progress-linear color="#cecece" indeterminate rounded height="6" />
        </div>
    </div> -->
    <div v-if="visible" style="font-size:0.85rem;color:#9e9e9e;text-align:center;margin:1rem 0 2rem;">
        <div v-if="!errVisible">
          <div>{{text}}</div>
          <div style="width:50%;margin:auto;margin-top:1.1rem;">
            <v-progress-linear color="#cecece" indeterminate rounded height="6" />
          </div>
        </div>
        <div v-else>
          <div style="width:50%;margin:auto;margin-top:1.1rem;">
            <div>{{err_text}}</div>
            <v-btn
              depressed
              color="blue-grey"
              style="margin-top: 10px;color: #fff;"
              @click="refresh"
            >
              刷新一下
            </v-btn>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      symbol: 3,
      timeout: null,
      text: '正在加载...',
      err_text: '页面加载失败，请重试',
      errVisible: false
    }
  },
  watch: {
  },
  computed: {
  },
  mounted() {
    this.waitTask()
  },
  destroyed() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  created() {
  },
  methods: {
    waitTask() {
      var that = this
      if (that.timeout) {
        window.clearTimeout(that.timeout)
      }
      that.timeout = setTimeout(() => {
        var that = this
        that.errVisible = true
      }, 10000);
    },
    refresh() {
      this.$router.go(0)
    }
  }
}
</script>

<style scoped>
</style>
